import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledListItemLoaderWrapper = styled.div`
    margin-bottom: 8px;
    display: flex;
    width: 100%;
`;

export const StyledListItemLoader = styled.div`
    border: 1px solid ${colorsPalettes.carbon[50]};
    margin-bottom: 8px;
    height: 64px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 8px;
    flex-direction: row;
    width: 100%;
`;

export const StyledListItemDescriptionLoader = styled.div`
    display: flex;
    margin-left: 20px;
    height: 44px;
    gap: 8px;
    flex-direction: column;
`;
